import * as Sentry from "@sentry/react"
import PropTypes from "prop-types"
import React from "react"
import { useDispatch } from "react-redux"
import Permissions from "react-redux-permissions"
import { Link, NavLink, useNavigate } from "react-router-dom"

import { useTranslate } from "context/translateContext"
import CONFIG from "core/config"
import { logout } from "data/actions/user/auth"
import { GENERAL_TOGGLE_MAIN_NAVIGATION } from "data/constants"

import logo from "../../images/wi-logo.svg"
import Dropdown from "../Dropdown"
import DropdownContent from "../Dropdown/DropdownContent"
import DropdownTrigger from "../Dropdown/DropdownTrigger"
import ZendeskButton from "../ZendeskButton/ZendeskButton"

import styles from "./Header.module.css"

const Header = ({ stateReady, name }) => {
  const { t: translate } = useTranslate()
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const logoutUser = () =>
    dispatch(logout()).then(res => {
      if (res.status !== "ERROR") {
        Sentry.getCurrentScope(scope => scope.clear())
        navigate("/")
      }
    })

  const toggleMenuOpen = () =>
    dispatch({
      type: GENERAL_TOGGLE_MAIN_NAVIGATION,
    })

  return (
    <header className={styles.root}>
      <div className={styles.logoSection}>
        <button
          type="button"
          className="icon-menu visible-xs visible-sm"
          onClick={toggleMenuOpen}
        ></button>
        <div className={styles.logo}>
          <Link to="/">
            <img src={logo} alt="WebInterpret logo" />
          </Link>
        </div>
      </div>

      {stateReady && (
        <div className="flex-container f-j-center f-a-center f-d-row gap-15">
          <ZendeskButton className="visible-sm-inline-block visible-md-inline-block visible-lg-inline-block" />
          <Dropdown className={styles.dropdown} right>
            <DropdownTrigger
              className={[styles.link, styles.userLink].join(" ")}
            >
              <span className={`${styles.user} hidden-xs`}>
                <span className={styles.name}>
                  <span className="block">{name}</span>
                  <span className="c-blue fs-12">{translate("Settings")}</span>
                </span>
                <span className="icon-arrow-down fs-12  lh-16" />
              </span>
              <span className={`${styles.user} visible-xs`}>
                <span className="icon-user fs-28" />
              </span>
            </DropdownTrigger>
            <DropdownContent className={styles.dropdownContent}>
              <ul className="l-unstyled">
                <li>
                  <NavLink
                    className={navData =>
                      navData.isActive ? styles.active : ""
                    }
                    to="/user/profile/contact-details"
                  >
                    <strong className="block">{name}</strong>
                    <span className="fs-12">{translate("View profile")}</span>
                  </NavLink>
                </li>

                <li className="separator" />
                <li>
                  <button onClick={() => logoutUser()} type="button">
                    {translate("Logout")}
                  </button>
                </li>
                <Permissions allowed={["admin"]}>
                  <li className="separator" />
                  <li>
                    <NavLink
                      className={navData =>
                        navData.isActive ? styles.active : ""
                      }
                      to="/user/permissions"
                    >
                      {translate("Permissions")}
                    </NavLink>
                  </li>
                  <li>
                    <a
                      href={`${CONFIG.portalAdminEbay}/admin/become_admin_user_back_again`}
                    >
                      <span className="icon-logout" /> {translate("Admin Ebay")}
                    </a>
                  </li>
                  <li>
                    <a
                      href={`${CONFIG.portalAdminAmazon}/admin/become_admin_user_back_again`}
                    >
                      <span className="icon-logout" />{" "}
                      {translate("Admin Amazon")}
                    </a>
                  </li>
                </Permissions>
              </ul>
            </DropdownContent>
          </Dropdown>
        </div>
      )}
    </header>
  )
}

Header.propTypes = {
  stateReady: PropTypes.bool,
  name: PropTypes.string,
}

Header.defaultProps = {
  stateReady: false,
  name: null,
}

export default Header
